/* globals Vue */

import App from './App'

init()

function init () {
	if (!isSupported()) return

	const rootE = document.querySelector('#js-order-request-replace')
	if (!rootE) return

	const app = new Vue(App)
	app.$mount(rootE)

	// Expose
	window.jsOrderRequestApp = app
}

function isSupported () {
	if (!window.$) {
		return false
	}
	if (typeof [].map !== 'function') {
		return false
	}
	return true
}
